import "./Hero.scss";

const Hero = () => {
	return (
		<main>
			<div className="title-custom">
				<h1>
					Steve<span>Gremory</span>
				</h1>
				<div className="navbar-hero">
					<ul>
						<li>
							<a href="https://github.com/SteveGremory/">GitHub</a>
						</li>
						<li>
							<a href="https://instagram.com/stevegremory">Instagram</a>
						</li>
						<li>
							<a href="https://twitter.com/stevegremory">Twitter</a>
						</li>
					</ul>
				</div>
			</div>
		</main>
	);
};

export default Hero;
